<template>
	<!-- <div class="home"> -->
		<div class="scroll-container">
		<!-- <div class="clearfix" style="height:75px;border: 2px solid #13314f;background-color: #dee8f3;">
			<img alt="FFS logo" src="../assets/nsf4.gif" style="float: left;height: 100%;padding: 2px;">
			<p style="float: left;margin: 0px;font-size: 16px;font-weight: bold;margin: 26px 0;">National Science Foundation</p>
			<v-btn style="float: right;top: 50%;transform: translateY(-75%);"
				rounded
				color="blue"
				@click="logout">
				Logout
			</v-btn>
			<p style="float: right;margin: 0px;font-size: 16px;font-weight: bold;margin: 26px 13px 26px 0;">Questionnairre v15</p>
		</div> -->
		<Survey v-bind:questions="questions" :previous-component-name="previousComponentName"/>
	</div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue';
import Survey from '@/components/Survey.vue';
import { authTokenService } from '@/services/authTokenService.js';
import { surveyService } from '@/services/surveyService.js';
import { authService } from '@/services/authService.js';
import { CONSTANTS } from "../common/constants";

export default {
	name: 'home',
	components: {
		Survey
	},
	data: () => ({
		questions: [],
		previousComponentName: null
	}),
	methods: {
		parseQuestions (questions) {
			if (questions && questions.length > 0) {
				const len = questions.length;
				for (let idx = 0; idx < len; idx++) {
					let q = questions[idx];

					if (q.bullets) {
						const bulletsText = q.bullets.replace(/[\n\r]/g, '');
						const bullets = JSON.parse(bulletsText);
						q.bullets = bullets;
					}

					if (q.columns) {
						const columnsText = q.columns.replace(/[\n\r]/g, '');
						const columns = JSON.parse(columnsText);
						q.columns = columns;
					}

					if (q.explaination) {
						const explainationText = q.explaination.replace(/[\n\r]/g, '');
						const explaination = JSON.parse(explainationText);
						q.explaination = explaination;
					}

					// casting a string into a boolean checks if that string is null, or empty
					if (q.crossCheck && Boolean(q.crossCheck)) {
						const crossCheckText = q.crossCheck.replace(/[\n\r]/g, '');
						const crossCheck = JSON.parse(crossCheckText);
						q.crossCheck = crossCheck;
					}

					// This store method may be deprecated. It has been commented out.
					// this.$store.commit(CONSTANTS.STORE.METADATA_MUTATION_NAME, { id: q.displayId, value: q });
				}
			}
		},
		logout () {
			authService.logout();
		}
	},
	mounted () {
		debugger;
		const me = this;
		me.previousComponentName = me.$route.params.previousComponentName;
		let surveyId = authTokenService.getActiveSurveyId();
    	// Call the store action to load section status info
		me.$store.dispatch('validation/loadQuestionStatuses');
		me.$store.dispatch('validation/loadSurveyValidationMessages');
		me.$store.dispatch('loadAllAnswers', { surveyId: surveyId, qId: 0 });

		surveyService.getSurvey(surveyId).then(function (response) {
			if (response && response.data) {
				const questions = response.data;
				me.parseQuestions(questions);
				let idx = 0;
				questions.forEach(element => {
					Vue.set(me.questions, idx++, element);
				});
    		}
		})
		.catch(function (e) {
			console.error(e);
			throw e;
		});
	}
};
</script>

<style scoped>
	.topMenu {
		position: fixed;
	}
	.scroll-container {
	/* overflow-y: hidden; */
	/* overflow-x: scroll;
	position: sticky;
	top: 0;
	height: 90%; */
	}
</style>
